<template lang="html">
  <div id="IpAdd">
    <el-container class="IPAddCont">
      <el-header>
        <div class="header-area">
        </div>
      </el-header>

      <el-main>
        <div class="header-inner-area">
          <ul>
            <li>
              <img class="logo" src="../../assets/image/logo-new.png" alt="LOGO" />
            </li>
          </ul>
        </div>
      </el-main>
    </el-container>
        <el-divider class="header-divider"></el-divider>
        <el-container class="IP_authentication_failed">

      <div id="SID0021__Container">
        <!-- Toaster section -->
        <section>
          <div  v-if="this.getElNotice0021 != '' && this.getElNotice0021 != null ">
          <el-alert v-show="El_Notice=true" :title="this.getElNotice0021"  class="mailToastDiv"></el-alert>
        </div>
        <div v-else>
          <el-alert v-show="El_Notice" :title="this.getElNotice0021"  class="mailToastDiv"></el-alert>
        </div>
        </section>
        <!-- Body section -->
        <section>
          <div class="spanBodyContent">
            <div v-if="this.getIpErrorMsg0021==true" >
              <span v-show="getIpErrorMsg0021=true" >IP認証に失敗しました。</span>
            </div>
            <div v-else >
              <span v-show="getIpErrorMsg0021" ></span>
            </div>
            
            
            <el-row class="buttonLoginRedirect">
              <el-button @click="loginIp" type="primary" plain>リトライ</el-button>
              <el-button @click="onSubmit" type="info" plain>ID/PW認証はこちら</el-button>
            </el-row>
          </div>
        </section>
      </div>
        </el-container>
      <el-container class="footer-div">
        <el-footer class="footer0021 footer-element">
          <FooterComponent />
          </el-footer>
      </el-container>

  </div>
</template>

<script lang="js">
import router from '../../router';
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";

  export default  {
    name: 'SID0021',
    components: {
		FooterComponent,
	},
    props: [],
    
    data () {
     return {
       input1:'',
       input2:'',
       getIpErrorMsg0021:true
      }
    },
    methods: {
		onSubmit() {
            this.$LogButtonEvent("0021","ID/PW認証はこちら");
            this.$LogMethodIN("0021","onSubmit");
            router.push({name:"0001"});
            this.$LogMethodOut("0021","onSubmit");
        },
    loginIp(){
      this.$LogButtonEvent("0021","Retry");
			this.$LogMethodIN("0021","loginIp");
      this.getIpErrorMsg0021=false;

      this.$store.dispatch('communication0021/IpChecking').then(() => {
        var IpMsg = this.getIpErrorMsg0021True;
        this.getIpErrorMsg0021=IpMsg;

      });
      this.$LogMethodOut("0021","loginIp");
    }
    },
    computed: {
		...mapGetters("situation0021", [
      //error message flag for getting response
      "getElNotice0021",
      "getIpErrorMsg0021True"
		])
  },
  mounted() {
    this.$store.dispatch('communication0021/checkEl_Notice');

    },
    created() {
      //For the screen Title
     document.title = "記事閲覧";
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
        this.$router.push('sp/0021');
    }
    else{
        this.$router.push('/0021');
    }

  },
   // beforeCreate(){
    //   Common.Session.CheckSessionExists_IfExpired_GoToLogout();
    // },
}
</script>

<style scoped>
@import "../../assets/css/style.css";
@import "0021.css";
</style>